function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "z3f2a",
  d: "M277.09 2156.87c0 12.67-14.215 22.94-31.75 22.94s-31.75-10.27-31.75-22.94c0-12.67 14.215-22.94 31.75-22.94s31.75 10.27 31.75 22.94z"
}), React.createElement("path", {
  id: "z3f2b",
  d: "M252.559 2142.488c.55.861 1.021 1.801 1.414 2.74 1.178 2.82 1.806 5.718 1.806 8.772 0 3.054-.628 6.03-1.806 8.771-1.178 2.663-2.75 5.09-4.87 7.205a22.983 22.983 0 0 1-7.227 4.855c-2.828 1.175-5.734 1.802-8.797 1.802-3.064 0-6.049-.627-8.798-1.802-2.67-1.174-5.106-2.74-7.227-4.855a22.906 22.906 0 0 1-4.87-7.205c-1.178-2.82-1.806-5.717-1.806-8.771 0-3.054.628-6.03 1.806-8.771 1.179-2.663 2.75-5.09 4.87-7.205a22.983 22.983 0 0 1 7.227-4.855c2.828-1.175 5.734-1.802 8.798-1.802 3.063 0 6.048.627 8.797 1.802.864.391 1.728.783 2.592 1.253l2.278-2.585c-4.084-2.506-8.719-3.837-13.667-3.837-6.991 0-13.511 2.663-18.381 7.596-4.87 4.934-7.698 11.512-7.698 18.482 0 6.97 2.67 13.47 7.62 18.326 4.948 4.933 11.468 7.596 18.38 7.596 6.99 0 13.51-2.663 18.38-7.596 4.87-4.934 7.62-11.434 7.62-18.326 0-5.325-1.65-10.494-4.634-14.8z"
}), React.createElement("path", {
  id: "z3f2c",
  d: "M259.519 2123c-.396 0-.792.156-1.108.548l-25.413 28.789-10.609-7.198c-.237-.156-.554-.234-.87-.234-1.03 0-1.9 1.095-1.347 2.19l11.48 21.123c.316.547.791.782 1.346.782.475 0 .95-.235 1.266-.704l26.442-43.027c.792-1.174-.158-2.269-1.187-2.269z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", {
  opacity: 0.7,
  transform: "rotate(-24 -4846.965 1582.43)"
}, React.createElement("use", {
  fill: "#effff6",
  xlinkHref: "#z3f2a"
})), React.createElement("g", {
  transform: "translate(-207 -2123)"
}, React.createElement("g", null), React.createElement("g", null, React.createElement("use", {
  fill: "#7d8998",
  xlinkHref: "#z3f2b"
})), React.createElement("g", null, React.createElement("use", {
  fill: "#7ed327",
  xlinkHref: "#z3f2c"
}))));

var SvgAboutCheckmark = function SvgAboutCheckmark(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 75,
    height: 61,
    viewBox: "0 0 75 61",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAboutCheckmark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/aboutCheckmark.58eb74a3.svg";
export { ForwardRef as ReactComponent };